import { render, staticRenderFns } from "./ModalCreateNewPersonalizationEntry.vue?vue&type=template&id=479eac16&scoped=true"
import script from "./ModalCreateNewPersonalizationEntry.vue?vue&type=script&lang=js"
export * from "./ModalCreateNewPersonalizationEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479eac16",
  null
  
)

export default component.exports